import { RtRequest } from "../../RtRequest";
import { RtResponse } from "../../RtResponse";
import { AbstractFilters, AbstractRow } from "../../RtTypes";
import { rowsCmp, Sorters } from "./clientSorting";

export type FnIsFiltered<
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
> = (row: TRow, filters: TFilters) => boolean;

export type ApplyRequestOptions<
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
> = {
  sorters?: Sorters<TRow>;
  isFiltered?: FnIsFiltered<TRow, TFilters>;
};

export const applyRequest = <
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
>(
  srcRows: readonly TRow[],
  request: RtRequest<TFilters>,
  options?: ApplyRequestOptions<TRow, TFilters>,
): RtResponse<TRow> => {
  const { page, pageSize, sortOrder, filters } = request;
  const { isFiltered } = options ?? {};
  const rows =
    filters && isFiltered
      ? srcRows.filter((row) => isFiltered(row, filters))
      : [...srcRows];
  const totalRows = rows.length;
  if (sortOrder?.length) {
    rows.sort(rowsCmp(sortOrder, options?.sorters ?? {}));
  }
  if (pageSize) {
    const start = page * pageSize;
    return { rows: rows.slice(start, start + pageSize), totalRows };
  }
  return { rows, totalRows };
};
